import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-8e657a50")
const _hoisted_1 = {
  key: 5,
  class: "_patchMark"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Patching", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "We'll be right back", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Join a game")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "subtext" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "brief" }, "Use lobby codes to enter a game and play with your family and friends!")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "How to play")
  ])
], -1)
const _hoisted_8 = { class: "subtext" }
const _hoisted_9 = { class: "brief" }
const _hoisted_10 = {
  key: 8,
  class: "flex history"
}
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = {
  key: 0,
  class: "_owner _free"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, "Free", -1)
const _hoisted_16 = {
  key: 1,
  class: "_owner"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, "Owned", -1)
const _hoisted_18 = { class: "subtext" }
const _hoisted_19 = { class: "brief" }
const _hoisted_20 = { class: "functions" }
const _hoisted_21 = {
  key: 0,
  class: "rating"
}
const _hoisted_22 = {
  key: 0,
  class: "count"
}
const _hoisted_23 = {
  key: 1,
  class: "rating"
}
const _hoisted_24 = { class: "features" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 1,
  class: "dev"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Ripple = _resolveComponent("Ripple")!
  const _component_LazyImage = _resolveComponent("LazyImage")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({game:true,linear: _ctx.linear,popout: _ctx.popout,history: _ctx.history,tutorial: _ctx.tutorial,join: _ctx.join,patching:_ctx.game && _ctx.game.patching !== undefined?_ctx.game.patching&&!_ctx.linear:false})
  }, [
    ((_ctx.game && !_ctx.game.patching ) || _ctx.linear)
      ? (_openBlock(), _createBlock(_component_Ripple, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.join)
      ? (_openBlock(), _createBlock(_component_LazyImage, {
          key: 1,
          hideExpand: true,
          src: "/stairs.svg"
        }))
      : (_ctx.tutorial)
        ? (_openBlock(), _createBlock(_component_LazyImage, {
            key: 2,
            tutorial: true,
            hideExpand: true,
            src: "/tutorial.svg"
          }))
        : (_ctx.history)
          ? (_openBlock(), _createBlock(_component_LazyImage, {
              key: 3,
              hideExpand: true,
              src: _ctx.game.image?_ctx.game.image:'https://cdn.jsdelivr.net/npm/movingicons_assets/svg/missing.svg'
            }, null, 8, ["src"]))
          : (!_ctx.tutorial && !_ctx.game.patching)
            ? (_openBlock(), _createBlock(_component_LazyImage, {
                key: 4,
                patching: _ctx.game && _ctx.game.patching && !_ctx.linear,
                hideExpand: true,
                src: _ctx.game.image?_ctx.game.image:'https://cdn.jsdelivr.net/npm/movingicons_assets/svg/missing.svg'
              }, null, 8, ["patching", "src"]))
            : _createCommentVNode("", true),
    (_ctx.game && _ctx.game.patching)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.join)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
          _hoisted_5,
          _hoisted_6
        ], 64))
      : (_ctx.tutorial)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.game.shortdescription), 1)
            ])
          ], 64))
        : (_ctx.history)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.game.title), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.getTime(_ctx.game.started)), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (!_ctx.linear && _ctx.game.free)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_component_MovingIcon, {
                          name: "tick",
                          hex: "#FFF",
                          type: "svg"
                        }),
                        _hoisted_15
                      ]))
                    : (!_ctx.linear && _ctx.game && _ctx.game.owner)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(_component_MovingIcon, {
                            name: "tick",
                            type: "svg",
                            hex: "#fff"
                          }),
                          _hoisted_17
                        ]))
                      : _createCommentVNode("", true),
                  _createElementVNode("h4", null, _toDisplayString(_ctx.game.title), 1),
                  _createElementVNode("p", null, [
                    _createElementVNode("div", {
                      class: _normalizeClass({difficulty:true,[`_${_ctx.difficulties[_ctx.game.difficulty]}`]:true})
                    }, null, 2),
                    _createTextVNode(" - " + _toDisplayString(_ctx.game.minutes) + " min", 1)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(_ctx.game.location), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.game.shortdescription), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                (_ctx.rating.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_MovingIcon, {
                        name: Math.min(Math.max(0,_ctx.rating.value),1)>0?'star_filled':'star',
                        hex: Math.min(Math.max(0,_ctx.rating.value),1)>0?'#000000':'#a0a0a0',
                        type: "svg"
                      }, null, 8, ["name", "hex"]),
                      _createVNode(_component_MovingIcon, {
                        name: Math.min(Math.max(0,_ctx.rating.value-1),1)>0?'star_filled':'star',
                        hex: Math.min(Math.max(0,_ctx.rating.value-1),1)>0?'#000000':'#a0a0a0',
                        type: "svg"
                      }, null, 8, ["name", "hex"]),
                      _createVNode(_component_MovingIcon, {
                        name: Math.min(Math.max(0,_ctx.rating.value-2),1)>0?'star_filled':'star',
                        hex: Math.min(Math.max(0,_ctx.rating.value-2),1)>0?'#000000':'#a0a0a0',
                        type: "svg"
                      }, null, 8, ["name", "hex"]),
                      _createVNode(_component_MovingIcon, {
                        name: Math.min(Math.max(0,_ctx.rating.value-3),1)>0?'star_filled':'star',
                        hex: Math.min(Math.max(0,_ctx.rating.value-3),1)>0?'#000000':'#a0a0a0',
                        type: "svg"
                      }, null, 8, ["name", "hex"]),
                      _createVNode(_component_MovingIcon, {
                        name: Math.min(Math.max(0,_ctx.rating.value-4),1)>0?'star_filled':'star',
                        hex: Math.min(Math.max(0,_ctx.rating.value-4),1)>0?'#000000':'#a0a0a0',
                        type: "svg"
                      }, null, 8, ["name", "hex"]),
                      (_ctx.rating.number)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, " (" + _toDisplayString(_ctx.rating.number) + ") ", 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(_component_MovingIcon, {
                        name: "loader_spinner",
                        autoplay: true,
                        loop: true
                      })
                    ])),
                _createElementVNode("div", _hoisted_24, [
                  (_ctx.game.features.web || _ctx.$router.isDev)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass({inactive:_ctx.$router.isDev&&!_ctx.game.features.web})
                      }, [
                        _createVNode(_component_MovingIcon, {
                          name: "web",
                          type: "svg"
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.game.features.maps || _ctx.$router.isDev)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass({inactive:_ctx.$router.isDev&&!_ctx.game.features.maps})
                      }, [
                        _createVNode(_component_MovingIcon, {
                          name: "maps",
                          type: "svg"
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.game.features.room || _ctx.$router.isDev)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass({inactive:_ctx.$router.isDev&&!_ctx.game.features.room})
                      }, [
                        _createVNode(_component_MovingIcon, {
                          name: "layout",
                          type: "svg"
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.game.features.video || _ctx.$router.isDev)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 3,
                        class: _normalizeClass({inactive:_ctx.$router.isDev&&!_ctx.game.features.video})
                      }, [
                        _createVNode(_component_MovingIcon, {
                          name: "start",
                          type: "svg"
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.game.features.downloads || _ctx.$router.isDev)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 4,
                        class: _normalizeClass({inactive:_ctx.$router.isDev&&!_ctx.game.features.downloads})
                      }, [
                        _createVNode(_component_MovingIcon, {
                          name: "download",
                          type: "svg"
                        })
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 64)),
    (_ctx.$router.isDev && _ctx.popout)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
          (_ctx.game.deleting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createVNode(_component_IconButton, {
                  icon: "loader_spinner",
                  autoplay: true,
                  loop: true
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createVNode(_component_IconButton, {
                  icon: "more_vert",
                  popout: _ctx.popout,
                  clear: true,
                  type: "svg",
                  white: true,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, null, 8, ["popout"])
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}